import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import type { ApolloError } from '@apollo/react-hooks';
import { type OVTS_COMPLETION_STATUS, type StudentSelectedTime } from './types';

type GetStudentSelectedTime = {
  studentSelectedTime: StudentSelectedTime;
  checkOVTSCompletion: OVTS_COMPLETION_STATUS | null;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

const GET_REGISTRATION_DATA = gql`
  query ($applicationId: String!) {
    selectedCollectionSlot(applicationId: $applicationId) {
      slotId
      slotName
      date
      meridiem
    }
    checkOVTSCompletion(applicationId: $applicationId)
  }
`;

export const useGetRegistrationData = (
  applicationId: string,
): GetStudentSelectedTime => {
  const { data, loading, error, refetch } = useQuery(GET_REGISTRATION_DATA, {
    variables: { applicationId },
    fetchPolicy: 'network-only',
    skip: !applicationId,
  });

  const selectedCollectionSlot = data?.selectedCollectionSlot ?? {};
  const studentSelectedTime: StudentSelectedTime = {
    slotId: selectedCollectionSlot?.slotId ?? '',
    slotName: selectedCollectionSlot?.slotName ?? '',
    date: selectedCollectionSlot?.date ?? '',
    meridiem: selectedCollectionSlot?.meridiem ?? '',
  };

  const checkOVTSCompletion = data?.checkOVTSCompletion ?? null;

  return {
    studentSelectedTime,
    checkOVTSCompletion,
    loading,
    error,
    refetch,
  };
};
